@if (control() && !control()?.valid && control()?.dirty) {
  <span
    class="form-control-validation-message"
    [translate]="getMessage()"
    [translateParams]="getMessageParams()"
  ></span>
}
